import React from 'react';
import { Users, FileText, Star, ThumbsUp } from 'lucide-react';
export const SocialProof: React.FC = () => {
  const stats = [{
    icon: <FileText className="w-6 h-6" data-id="element-252" />,
    value: '300+',
    label: 'Recursos digitales'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-253" />,
    value: '1.2k+',
    label: 'Profesores activos'
  }, {
    icon: <Star className="w-6 h-6 text-yellow-400 fill-current" data-id="element-254" />,
    value: '4.8/5',
    label: 'Valoración promedio'
  }, {
    icon: <ThumbsUp className="w-6 h-6" data-id="element-255" />,
    value: '100%',
    label: 'Satisfacción'
  }];
  return <section className="py-12 bg-white" data-id="element-256">
      <div className="max-w-6xl mx-auto px-4" data-id="element-257">
        <div className="bg-green-50 border border-green-100 rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-258">
          <div className="text-center mb-8" data-id="element-259">
            <h2 className="text-xl md:text-2xl font-bold text-green-800" data-id="element-260">
              Ya elegido por 1.200+ profesores de gimnasia en toda Argentina
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-261">
            {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center text-center p-4 bg-white rounded-xl shadow-sm border border-gray-50" data-id="element-262">
                <div className="text-green-600 mb-3 bg-green-50 p-3 rounded-full" data-id="element-263">
                  {stat.icon}
                </div>
                <span className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-1" data-id="element-264">
                  {stat.value}
                </span>
                <span className="text-sm font-medium text-gray-600" data-id="element-265">
                  {stat.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};